/**
 * Session cache for Settings → Canned responses list.
 * Survives tab unmount; revisit shows cached list while refetching in background.
 */
const emptyCache = () => ({
  businessId: null,
  data: null,
  hasFetched: false,
});

let cache = emptyCache();

export function getCannedResponsesWarmCache() {
  return cache;
}

export function setCannedResponsesWarmCache(next) {
  cache = { ...emptyCache(), ...next };
}

export function clearCannedResponsesWarmCache() {
  cache = emptyCache();
}
